/**
 * Authors: mariushirjanu
 * Created: 04/08/2021
 */
import { Component } from '@angular/core';

@Component({
  selector: 'company-profiles-invoice',
  template: `
    <h2>Invoice Templates</h2>
    <ui-view></ui-view>
  `
})
export class CompanyProfilesInvoiceComponent {
}